import script from "./RollSkillDice.vue?vue&type=script&setup=true&lang=ts"
export * from "./RollSkillDice.vue?vue&type=script&setup=true&lang=ts"

import "./RollSkillDice.vue?vue&type=style&index=0&id=9890d354&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\stani\\OneDrive\\Documents\\Git\\fate-extended\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9890d354"]])

export default __exports__